<div class="field mb-4">
  <!-- Start::título -->
  <span class="text-900 text-2xl block font-semibold mb-5"
    >Ingresa la dirección de facturación</span
  >
  <!-- End::título -->

  @if(sessionService.isEnterprise() || (isLoadedBusiness &&
  isRegisteredBusiness)){
  <!-- Start::selector de direcciones -->
  <div
    class="flex p-4 mt-3 lg:mt-0 mb-4 border-round border-1 w-full flex align-items-center justify-content-between min-h-6rem"
    [ngClass]="
      isLoadingAddress() ? 'surface-border' : 'border-primary bg-blue-50'
    "
  >
    @if(isLoadingAddress()){
    <!-- Start::skeleton de carga de dirección seleccionada -->
    <div class="flex flex-column gap-2">
      <p-skeleton width="14rem" />
      <p-skeleton width="24rem" />
    </div>
    <p-skeleton width="2rem" styleClass="ml-auto" />
    <!-- End::skeleton de carga de dirección seleccionada -->

    } @else {
    <!-- Start::card de dirección seleccionada o sin seleccionar -->
    <div class="flex flex-column gap-1">
      <div class="font-semibold uppercase">
        {{ selectedAddress?.address }}
      </div>
      <span class="text-sm">{{ selectedAddress?.city }}</span>
    </div>
    <!-- End::card de dirección seleccionada o sin seleccionar -->
    }
  </div>
  <!-- End::selector de direcciones -->
  } @else if(isLoadedBusiness && !isRegisteredBusiness) {
  <!-- Start::selector de misma dirección de envío o dirección distinta -->
  <form [formGroup]="useDeliveryAddressForm">
    @if(checkoutService.shippingType() === 'DELIVERY'){
    <div class="flex flex-column lg:flex-row field p-0 gap-3">
      @for(type of useDeliveryAddressOptions; track $index){
      <div
        class="flex p-3 border-round border-1 surface-border w-full cursor-pointer flex align-items-center h-6rem"
        [ngClass]="{
          'surface-border hover:border-400':
            useDeliveryAddressField?.value !== type.value,
          'border-primary bg-blue-50':
            useDeliveryAddressField?.value === type.value
        }"
        (click)="onSelectUseDeliveryAddress(type.value)"
      >
        <p-radioButton
          name="useDeliveryAddress"
          [value]="type.value"
          formControlName="useDeliveryAddress"
          styleClass="mr-3"
        />
        <div class="mr-4 md:mr-6">
          <div class="font-semibold">{{ type.title }}</div>
        </div>
      </div>
      }
    </div>
    }
  </form>
  <!-- End::selector de misma dirección de envío o dirección distinta -->
  }
</div>

@if(!useDeliveryAddress && !sessionService.isEnterprise() && isLoadedBusiness
&& !isRegisteredBusiness){
<!-- Start::formulario de dirección -->
<form
  #invoiceAddressFormElement
  [formGroup]="invoiceAddressForm"
  (ngSubmit)="nativeSubmit()"
>
  <app-address-form-control-container [useMap]="false" />
</form>
<!-- End::formulario de dirección -->

}
